import getStore from '../store/configureStore';
import _get from 'lodash/get';
import templateData from '../../utility/getTemplateData';
import _isEmpty from 'lodash/isEmpty';

export function getDonateButtonImageUrl(
  buttonSize,
  showAcceptedCardLogos,
  languageCode,
  countryCode
) {
  const reduxStore = getStore();
  const countryAndLanguageDetails = _get(
    reduxStore.getState(),
    'application.countryAndLanguageDetails'
  );
  let url = _get(
    countryAndLanguageDetails,
    `countriesByCode.${countryCode}.languages.${languageCode}.buttonImageUrl`,
    {}
  );

  if (buttonSize === 'large') {
    if (showAcceptedCardLogos) {
      url = url.cc;
    } else {
      url = url.large;
    }
  } else {
    url = url.small;
  }

  return url;
}

export const getButtonImageAndUrl = (
  buttonSize,
  showAcceptedCardLogos,
  locale,
  country
) => {
  const buttonImageUrl = getDonateButtonImageUrl(
    buttonSize,
    showAcceptedCardLogos,
    locale,
    country
  );
  let buttonImage = 'REG';
  if (showAcceptedCardLogos) {
    buttonImage = 'CC';
  }

  if (buttonSize === 'small') {
    buttonImage = 'SML';
  }

  return {
    buttonImage: buttonImage,
    buttonImageUrl: buttonImageUrl,
  };
};

export const shouldUsePayPalButtonStyle = (buttonImageUrl) => {
  if (!_isEmpty(buttonImageUrl)) {
    if (
      buttonImageUrl.includes('btn_donate') &&
      buttonImageUrl.includes(templateData.cdnHostName)
    ) {
      return 'yes';
    }
  }

  return 'no';
};
